/**
 * ObjectTabSet React component
 * 
 * @author    Maurizio Tidei, Jens Gruschel
 * @copyright © 2018 contexagon GmbH
 */


// React
import React from 'react';
import PropTypes from 'prop-types';

// Material-UI
import {withStyles} from "@material-ui/core";
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

// application
import ObjectFieldSetPanel from "./ObjectFieldSetPanel";
import {ACCESS_WRITABLE} from "../../redux/authorization/consts";


/**
 * ObjectTabSet is a React component representing field sets of an object
 *
 * @author Maurizio Tidei, Jens Gruschel
 */
export class ObjectTabSet extends React.Component {

    render() {

        const fieldSetDefinitions = this.props.fieldSet.fieldsets;
        const selectedFieldSet = fieldSetDefinitions[this.props.tabIndex];
        const fieldSetReadOnly = this.props.readOnly || selectedFieldSet.accessLevel < ACCESS_WRITABLE;

        const sideBarFieldSets = this.props.sideBarFieldSets ? this.props.sideBarFieldSets.filter(
            fieldSet => fieldSet.joinsidebar === selectedFieldSet.id
        ) : [];

        return (
            <div>
                <AppBar className={this.props.classes.tabs} position="static" color="default">
                    <Tabs
                        value={this.props.tabIndex}
                        onChange={this.props.onTabChange}
                        indicatorColor="primary"
                        textColor="primary"
                        variant="scrollable"
                        scrollButtons="auto"
                        style={{background:"white"}}
                    >
                        {fieldSetDefinitions.map((fieldset, i) => {

                            return <Tab key={fieldset.id} label={fieldset.name}/>;
                        })}
                    </Tabs>
                </AppBar>
                <div id="fields">
                    <ObjectFieldSetPanel
                        fieldSet={selectedFieldSet}
                        sideBarFieldSets={sideBarFieldSets}
                        objectType={this.props.objectType}
                        objectId={this.props.objectId}
                        object={this.props.object}
                        readOnly={fieldSetReadOnly}
                        scope={this.props.scope}
                        onObjectValueChange={this.props.onObjectValueChange}
                    />
                </div>
            </div>
        );
    }
}

const styles = theme => ({
    tabs: {
        boxShadow: "none"
    }
});

ObjectTabSet.propTypes = {
    fieldSet: PropTypes.object.isRequired,
    sideBarFieldSets: PropTypes.array,
    objectType: PropTypes.string,
    objectId: PropTypes.string,
    object: PropTypes.object.isRequired,
    readOnly: PropTypes.bool,
    onObjectValueChange: PropTypes.func.isRequired,
    tabIndex: PropTypes.number,
    scope: PropTypes.arrayOf(PropTypes.string),
    onTabChange: PropTypes.func.isRequired
};

export default withStyles(styles)(ObjectTabSet);